import { useTranslation } from 'react-i18next';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~/components/ui/alert-dialog';

import type { RedeliveryBlockReason } from '../utils/redelivery-gate';

/** Why the gate refused — the gate's own reasons plus the batch header failing to load. */
export type RedeliveryBlockedReason = RedeliveryBlockReason | 'batchMissing';

interface Props {
  /** `null` = closed. */
  reason: RedeliveryBlockedReason | null;
  onClose: () => void;
}

/** Popup shown in place of the redeliver wizard when "Retry delivery" can't start. */
export function RedeliveryBlockedDialog({ reason, onClose }: Props) {
  const { t } = useTranslation('common');
  const body =
    reason === 'membersOnly'
      ? t('deliveryWizard.redeliver.membersOnly')
      : reason
        ? t(`deliveryWizard.redeliver.blocked.${reason}`)
        : '';

  return (
    <AlertDialog
      open={reason !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <AlertDialogContent data-testid="redelivery-blocked-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t('deliveryWizard.redeliver.blocked.title')}</AlertDialogTitle>
          <AlertDialogDescription>{body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            data-testid="redelivery-blocked-dialog-close-button"
            className="cursor-pointer"
            onClick={onClose}
          >
            {t('deliveryWizard.redeliver.blocked.dismiss')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
